export const MixedAirlineKey = "Mixed Airline";

export const AircraftUnknown = "Unknown";

export const MaxPointsSliderSort = ["Economy", "PremiumEconomy", "First", "Business"];
export const TimesSliderSort = ["DepartureTime", "ArrivalTime"];

export const CabinsMap = new Map([
  ["Economy", "Economy"],
  ["PremiumEconomy", "Premium Economy"],
  ["Business", "Business"],
  ["First", "First"],
]);

export const lastTimeOptions = [
  {
    value: `${3600 * 3}`,
    label: "Earlier than 3 hours",
  },
  {
    value: `${3600 * 12}`,
    label: "Earlier than 12 hours",
  },
  {
    value: `${3600 * 24}`,
    label: "Less than 1 day ago",
  },
  {
    value: `${3600 * 24 * 3}`,
    label: "Less than 3 day ago",
  },
  {
    value: `${3600 * 24 * 5}`,
    label: "Less than 5 days ago",
  },
];
